import React from "react";

/**
 * The standard course a product belongs to, or a "No course yet" chip. Only rendered when the catalog is hosted on the
 * Standard courses page, which passes `courseLinks`. The actions that give a product a course are in CourseActions.
 */
export default function CourseCell({ product, courseLinks, onOpenCourse }) {
  const course = courseLinks[product.key];
  if (course) {
    return (
      <span className="ac-course">
        <button type="button" className="ac-link" aria-label={`Open ${course.title}`} onClick={() => onOpenCourse(course)}>{course.title}</button>
        {course.status === "RETIRED" && <span className="ac-hint">Retired</span>}
      </span>
    );
  }
  return <span className="ac-course"><span className="ac-chip inactive">No course yet</span></span>;
}

/** Create a course from the product, or link it to an existing one. Shown in the row's actions, only for a product with no course. */
export function CourseActions({ product, courseLinks, onCreateCourse, onLinkCourse }) {
  if (courseLinks[product.key]) return null;
  return (
    <span className="ac-course-actions">
      <button type="button" className="ac-sbtn" aria-label={`Create course from ${product.name}`} onClick={() => onCreateCourse(product)}>Create course</button>
      <button type="button" className="ac-sbtn" aria-label={`Link ${product.name} to a course`} onClick={() => onLinkCourse(product)}>Link course</button>
    </span>
  );
}
